/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["form[_ngcontent-%COMP%]{display:flex}table[_ngcontent-%COMP%]{width:100%}th[_ngcontent-%COMP%]{text-align:left}"];
export { styles as styles };
